import { render, staticRenderFns } from "./CbsBpmDesigner.vue?vue&type=template&id=4dd6241f&scoped=true"
import script from "./CbsBpmDesigner.vue?vue&type=script&lang=js"
export * from "./CbsBpmDesigner.vue?vue&type=script&lang=js"
import style0 from "./CbsBpmDesigner.vue?vue&type=style&index=0&id=4dd6241f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd6241f",
  null
  
)

export default component.exports